module.exports = __webpack_public_path__ + "static/media/blog-placeholder.46587107.jpg";